export const initialState = {
    menu: false,
    navigation: 'Home',
    currentUser: null,
    user: null,
    appnav: false,
    appIconState: null
};
export function reducer(state, action) {
    switch (action.type) {
        case "MENU":
            return {
                ...state,
                menu: action.menu,
            };
        case "ACTIVE_NAVIGAtION":
            return {
                ...state,
                navigation: action.navigation,
            };
        case "LOGIN": {
            return {
                currentUser: action.payload,
            };
        }
        case "LOGOUT": {
            return {
                currentUser: null,
            };
        }
        case "CREATE_USER":
            return {
                ...state,
                user: action.user,
            };
        case "APP_NAV_STATE":
            return {
                ...state,
                appnav: action.appnav,
            };
            case "APP_ICON_STATE":
                return {
                    ...state,
                    appIconState: action.appIconState,
                };
        default:
            return state;
    }
}